import { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { inr } from "../landing/usePricing";

const KYC = { approved: "text-emerald-300", rejected: "text-red-300", pending: "text-amber-300" };

export const HkEmployees = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    adminApi.get("/admin/hk/employees").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  if (!items) return <p className="py-6 text-center text-slate-500">Loading…</p>;
  return (
    <div data-testid="hk-employees" className="space-y-2">
      <p className="text-xs text-slate-400">Employees registered in "Book Service" or "Housekeeping & Home Services" ({items.length}). Use the reference to assign them to a booking.</p>
      {items.length === 0 && <p className="py-6 text-center text-slate-500">No employees yet.</p>}
      <div className="overflow-x-auto">
        <table className="w-full min-w-[820px] text-sm">
          <thead><tr className="border-b border-white/10 text-left text-xs uppercase text-slate-400">
            {["Name", "Mobile", "Role", "KYC", "Telegram", "Today's jobs", "Jobs done", "Earned (month)", "Earned (total)"].map((h) => <th key={h} className="py-2 pr-3 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>
            {items.map((w) => (
              <tr key={w.id} data-testid={`hk-emp-${w.reference}`} className="border-b border-white/5">
                <td className="py-2 pr-3"><span className="font-semibold text-white">{w.full_name}</span><br /><span className="font-mono text-xs text-orange-300">{w.reference}</span></td>
                <td className="py-2 pr-3 font-mono">{w.mobile}</td>
                <td className="py-2 pr-3">{w.job_role}<br /><span className="text-xs text-slate-500">{w.department === "book_service" ? "Book Service" : "Housekeeping"} · {w.district}</span></td>
                <td className={`py-2 pr-3 capitalize ${KYC[w.kyc_status] || "text-slate-300"}`}>{w.kyc_status}</td>
                <td className="py-2 pr-3">{w.telegram ? <span className="text-sky-300">Connected</span> : <span className="text-slate-500">No</span>}</td>
                <td className="py-2 pr-3 text-center">{w.today_jobs}</td>
                <td className="py-2 pr-3 text-center">{w.jobs_done}</td>
                <td className="py-2 pr-3 font-mono text-emerald-300">{inr(w.earned_month)}</td>
                <td className="py-2 pr-3 font-mono">{inr(w.earned_total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
